import styled from 'styled-components'
import Footer from '../../components/Footer'

const StyledFooter = styled(Footer)`
  background: linear-gradient(to right, #3b8e64, #103027);
  bottom: 0;
  display: flex;
  left: 0;
  position: fixed;
  right: 0;
  z-index: 1;
`

export default StyledFooter



// WEBPACK FOOTER //
// ./src/pages/living-room/_StyledFooter.js